import { Dialog } from "@components/ui/Dialog"
import { useWishlistModals } from "./useWishlist"
import { useSnapshot } from "valtio"
import { FilmSessionFragment } from "@generated-types"
import { Button } from "@components/ui/Button"
import { SessionTicketWidget } from "@components/film/SessionTicketWidget"
import { SelectableSessionItem } from "@components/film/SelectableSessionItem"
import { ButtonGroup } from "@components/ui/ButtonGroup"
import { useState } from "react"
import { useFerve } from "@features/ferve/FerveProvider"

export type WishlistMultiSelectionProps = {
  sessions: FilmSessionFragment[]
}

function WishlistSelectModal(props: WishlistMultiSelectionProps & { onClose: () => void }) {
  const wishlist = useFerve().wishlist
  const [selected, setSelected] = useState<number[]>([])

  return (
    <Dialog
      open={true}
      onOpenChange={(open) => {
        if (!open) {
          props.onClose()
        }
      }}
      onDismiss={props.onClose}
      className="w-grid md:w-auto max-w-[420px]"
    >
      <Dialog.Title className="type-title-s">Select Sessions</Dialog.Title>
      <Dialog.Description className="type-body-m mt-[0.3em] text-fg-secondary">
        Choose which sessions you'd like to add to your watchlist:
      </Dialog.Description>
      <div className="flex flex-col gap-2 mt-4 mb-5 @container">
        {props.sessions.map((session) => (
          <SelectableSessionItem
            key={session.id}
            session={session!}
            variant="outline"
            selectable
            checked={selected.includes(session.info?.ferveId!)}
            onCheckedChange={() => {
              if (selected.includes(session.info?.ferveId!)) {
                setSelected(selected.filter((id) => id !== session.info?.ferveId!))
              } else {
                setSelected([...selected, session.info?.ferveId!])
              }
            }}
          />
        ))}
      </div>
      <ButtonGroup variant="dialog">
        <Button variant="outline" onClick={() => props.onClose()}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={selected.length === 0}
          onClick={() => {
            for (const id of selected) {
              wishlist.add(String(id))
            }
            props.onClose()
          }}
        >
          Add Selected
        </Button>
      </ButtonGroup>
    </Dialog>
  )
}

export function WishlistModals() {
  const { store } = useWishlistModals()
  const snapshot = useSnapshot(store)

  if (snapshot.modal) {
    return (
      <WishlistSelectModal
        {...(snapshot.modal as WishlistMultiSelectionProps)}
        onClose={() => {
          store.modal = null
        }}
      />
    )
  }
}
